import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link } from 'react-router-dom';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';

// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import getLocale from '../../i18n/getLocale';

class StaffPapersManager extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      data: []
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.delete = this.delete.bind(this);
    this.deleteRow = this.deleteRow.bind(this);
    this.loadData = this.loadData.bind(this);
    this.ActionsButtons = this.ActionsButtons.bind(this);

    this.locale = getLocale();
  }

  // Handlers
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }


  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData() {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/funcionario/papeletas/gestor', { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({data: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); /* Overlay */
    });
  }

  ActionsButtons (cell, row) {
    var url = '/papeleta/editar/' + cell;

    var botao = (
      <div className="btn-group">
        <Link className={'btn btn-primary btn-sm'} to={url}>
          <i className="fa fa-fw fa-pencil"></i>
        </Link>
      </div>
    );

    return botao;
  }
  delete (event) {
    var fira_id = event.currentTarget.value;
    var confirm = window.confirm(this.locale.Papeletas.ListaDePapeletasPendentesGestor.deletar);
    if (confirm) {
      this.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/papeleta/' + fira_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.deleteRow(fira_id);
          }
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  deleteRow(fira_id) {
    var data = this.state.data;
    data.map(function(dado, index){
      if (dado.id == fira_id) {
        data.splice(index, 1);
      }
    });
    this.setState({data: data});
  }

  render() {
    return (
<div>
  
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title">{this.locale.Papeletas.ListaDePapeletasPendentesGestor.titulo}</h3>
      <hr/>
      <BootstrapTable data={this.state.data} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.Papeletas.ListaDePapeletasPendentesGestor.tabela.semPapeletasPendentes}} search={true} multiColumnSearch={true}  searchPlaceholder={this.general.procurar}>

        <TableHeaderColumn dataField="id" isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='60'>{this.locale.Papeletas.ListaDePapeletasPendentesGestor.tabela.ID}</TableHeaderColumn>

        <TableHeaderColumn dataField="staff_name" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.general.procurar}}>{this.locale.Papeletas.ListaDePapeletasPendentesGestor.tabela.Nome}</TableHeaderColumn>
        <TableHeaderColumn dataField="staff_inscription" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.general.procurar}}>{this.locale.Papeletas.ListaDePapeletasPendentesGestor.tabela.Matricula}</TableHeaderColumn>
        <TableHeaderColumn dataField="month" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.general.procurar}}>{this.locale.Papeletas.ListaDePapeletasPendentesGestor.tabela.Referencia}</TableHeaderColumn>

        <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.ActionsButtons} width='100'>{this.locale.Papeletas.ListaDePapeletasPendentesGestor.tabela.Acoes}</TableHeaderColumn>

      </BootstrapTable>
    </div>
  </div>
</div>
    );
  }
}

export default StaffPapersManager;



// WEBPACK FOOTER //
// ./src/Components/StaffPapers/StaffPapersManager.js